import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { LuCheck } from 'react-icons/lu'
import { recurrencyCopy } from '../copy'

type RecurrencyTermsCheckboxProps = {
  version: string
  url: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export const RecurrencyTermsCheckbox = ({
  version,
  url,
  checked,
  onChange,
  disabled
}: RecurrencyTermsCheckboxProps) => (
  <div className="flex items-start gap-2">
    <CheckboxPrimitive.Root
      id="recurrency-terms"
      checked={checked}
      onCheckedChange={(next) => onChange(next === true)}
      disabled={disabled}
      className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 border-solid border-gray-300 bg-white text-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 data-[state=checked]:border-primary-700">
      <CheckboxPrimitive.Indicator>
        <LuCheck className="h-3 w-3" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
    <label htmlFor="recurrency-terms" className="text-sm text-gray-800">
      {recurrencyCopy.payment.terms(version)}{' '}
      <a href={url} target="_blank" rel="noopener noreferrer" className="font-semibold text-primary-700 underline">
        {recurrencyCopy.payment.termsLink}
      </a>
    </label>
  </div>
)
